(function () {
  'use strict';
  var words = /(?<![\p{L}\p{N}])p[eé]ptidos?(?![\p{L}\p{N}])/giu;
  var navigation = '.nav, .mnav-links, .ch-tabs, .ch-more-p, .coll-tabs, .fnx-hybrid-families';
  var skip = 'script, style, noscript, template, textarea, input, [contenteditable="true"]';
  function cleanText(value) {
    return String(value || '').replace(words, '').replace(/ {2,}/g, ' ').replace(/ +([,.;:])/g, '$1');
  }
  window.NM = window.NM || {};
  window.NM.cleanText = cleanText;
  function cleanTree(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (!node.parentElement || node.parentElement.closest(skip)) return;
      var value = cleanText(node.nodeValue);
      if (value !== node.nodeValue) node.nodeValue = value;
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE || node.matches(skip)) return;
    if (node.matches('a') && node.closest(navigation) && /^composici[oó]n(?: corporal)?$/i.test(node.textContent.trim())) {
      var row = node.closest('li'); (row || node).remove(); return;
    }
    if (node.matches('a') && node.closest(navigation) && /^ashwagandha$/i.test(node.textContent.trim())) {
      node.textContent = window.NM.catalogFavorites || 'Favoritos';
      node.href = window.NM.catalogFavoritesUrl || '/collections/racetams';
    }
    ['aria-label', 'title', 'alt'].forEach(function (name) {
      if (!node.hasAttribute(name)) return;
      var before = node.getAttribute(name), after = cleanText(before);
      if (before !== after) node.setAttribute(name, after.trim());
    });
    Array.from(node.childNodes).forEach(cleanTree);
    if (node.matches('a') && node.closest(navigation) && !node.textContent.trim()) {
      var item = node.closest('li'); (item || node).remove();
    } else if (node.matches('.chip') && !node.textContent.trim()) node.hidden = true;
  }
  function boot() {
    document.title = cleanText(document.title);
    cleanTree(document.body);
    var observer = new MutationObserver(function (changes) {
      observer.disconnect();
      changes.forEach(function (change) {
        if (change.type === 'characterData') cleanTree(change.target);
        else if (change.type === 'attributes') cleanTree(change.target);
        else change.addedNodes.forEach(cleanTree);
      });
      observe();
    });
    function observe() { observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title', 'alt'] }); }
    observe();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
